import $ from 'jquery'
import messageResource from '../../messageResource'
import {Errors} from './constants'
import ChartHierarchicalSelectorsSectionStrategy from './ChartHierarchicalSelectorsSectionStrategy'

function BalanceHierarchicalSelectorsSectionStrategy({showUserSelector, balanceUserSelector}) {
    this.params = {
        showUserSelector,
        balanceUserSelector,
    }
}

BalanceHierarchicalSelectorsSectionStrategy.prototype = new ChartHierarchicalSelectorsSectionStrategy();

BalanceHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI = function()
{
    ChartHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI.call( this );
    let classes = this.params.showUserSelector ? this.getVisibleBalanceUsersSelectorClassName() : " " + this.getVisibleUsernameClassName()
    classes += " " + this.getVisibleNoteMsgClassName()
    $( this.container ).addClass(classes);
    this.noteMsgContainer.innerHTML = messageResource.getMessage("report.chart.balance_shown_within_date_range");
};

BalanceHierarchicalSelectorsSectionStrategy.prototype.withUserSelector = function() {
    return this.params.showUserSelector
}

BalanceHierarchicalSelectorsSectionStrategy.prototype.getUserSelection = function() {
    return this.params.balanceUserSelector.getSelection()
}

BalanceHierarchicalSelectorsSectionStrategy.prototype.getSelectedParams = function()
{
    return {
        userSelection: this.params.balanceUserSelector.getSelection()
    };
};

BalanceHierarchicalSelectorsSectionStrategy.prototype.validate = function() {
    const errors = []

    if (!this.validateIsUserSelected())
        errors.push(Errors.ERROR_EMPTY_BALANCE_USER_SELECTION)

    return errors
}

BalanceHierarchicalSelectorsSectionStrategy.prototype.validateIsUserSelected = function() {
    return this.params.balanceUserSelector.validateIsUserSelected()
}

BalanceHierarchicalSelectorsSectionStrategy.prototype.setUserSelection = function(selection) {
    this.params.balanceUserSelector.setSelection(selection)
}

export default BalanceHierarchicalSelectorsSectionStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/BalanceHierarchicalSelectorsSectionStrategy.js